let oldValues = {};
let addressChanged = false;

const fields = [
  '[name=organizationName]',
  '[name=organization-name]',
  '[name=address]',
  '[name=address2]',
  '[name=city]',
  '[name=country]',
  '[name=stateInput]',
  '[name=state]',
  '[name=stateInput]',
  '[name=postal-code]',
  '[name=postalCode]'
];

function onAddressChange() {
  const currentValues = getFormValues();

  addressChanged = JSON.stringify(currentValues) !== JSON.stringify(oldValues);
}

function isChanged() {
  return addressChanged;
}

function updateAddress() {
  oldValues = getFormValues();
  addressChanged = false;
}

function getFormValues() {
  const values = {};

  fields.forEach((field) => {
    values[field] = $(field).val();
  });

  return values;
}

$(() => {
  setTimeout(() => {
    updateAddress();
  }, 0);

  $(fields.join(', ')).change(onAddressChange);
});

module.exports = { isChanged, updateAddress };
